import { z } from "zod";
import { FoundationSemVerSchema, FoundationTimestampSchema } from "./foundation.js";
import { JsonValueSchema } from "./primitives.js";
export const McpToolNameSchema = z
    .string()
    .regex(/^[a-z][a-z0-9_]*(?:\.[a-z][a-z0-9_]*)+\.v[1-9]\d*$/);
export const McpManifestFieldSummarySchema = z
    .object({
    name: z.string(),
    type: z.string(),
    required: z.boolean(),
    description: z.string().optional(),
    sensitive: z.boolean().optional(),
})
    .strict();
export const McpToolManifestEntrySchema = z
    .object({
    name: McpToolNameSchema,
    version: FoundationSemVerSchema,
    server: z.string(),
    namespace: z.string(),
    status: z.enum(["proposed", "experimental", "active", "deprecated", "retired"]),
    description: z.string().min(1),
    operationClass: z.enum([
        "read",
        "search",
        "prepare",
        "validate",
        "render",
        "commit",
        "transition",
        "administrative",
        "explain",
    ]),
    riskTier: z.enum(["R0", "R1", "R2", "R3", "R4"]),
    latencyClass: z.enum(["L0_inline", "L1_interactive", "L2_bounded", "L3_background"]),
    sideEffect: z.boolean(),
    approvalPolicy: z.enum([
        "none",
        "review_if_displayed",
        "explicit_review",
        "exact_payload_signature",
        "dual_authorization",
        "restricted",
    ]),
    authScopes: z.array(z.string()).min(1),
    contextRequirements: z.array(z.string()),
    idempotency: z.enum(["not_applicable", "optional", "required"]),
    cachePolicy: z.enum([
        "none",
        "request",
        "version_keyed",
        "short_lived",
        "directory_ttl",
        "immutable",
    ]),
    concurrencyPolicy: z.string().optional(),
    dataClassification: z.array(z.string()).optional(),
    inputFields: z.array(McpManifestFieldSummarySchema),
    outputFields: z.array(McpManifestFieldSummarySchema),
    inputSchemaRef: z.string().optional(),
    outputSchemaRef: z.string().optional(),
    fhirMappings: z.array(z.string()).optional(),
    dependsOn: z.array(z.string()).optional(),
    failureSemantics: z.array(z.string()).min(1),
    auditEvents: z.array(z.string()).min(1),
    rateLimitClass: z.string().optional(),
    timeoutMs: z.number().int().min(1).optional(),
    tags: z.array(z.string()).optional(),
})
    .strict();
export const McpToolManifestSchema = z
    .object({
    catalogVersion: FoundationSemVerSchema,
    generatedAt: FoundationTimestampSchema,
    protocolVersion: z.string(),
    defaults: z.record(z.string(), JsonValueSchema).optional(),
    tools: z.array(McpToolManifestEntrySchema),
})
    .strict();
//# sourceMappingURL=mcp-manifest.js.map